exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}.\\+YuJSIHzqViEzJ7GutDaXg\\=\\={position:fixed;width:100%;top:var(--additionalTopHeaderHeight,0);z-index:10;color:#000}html[dir] .\\+YuJSIHzqViEzJ7GutDaXg\\=\\={background:#fff}.EBSYfCAJgD\\+-07kRtTXBtg\\=\\={position:absolute!important;z-index:10!important}", ""]);
// Exports
exports.locals = {
	"mailReadingPaneHeader": "+YuJSIHzqViEzJ7GutDaXg==",
	"detailsFromReadingPane": "EBSYfCAJgD+-07kRtTXBtg=="
};